/**
 * @generated SignedSource<<14c8890492669413f19ee38f4d4f5ceb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WhatToSeeBlocksField_blocksConnection$data = {
  readonly " $fragmentSpreads": FragmentRefs<"WhatToSeeBlocksFieldSections_blocksConnection">;
  readonly " $fragmentType": "WhatToSeeBlocksField_blocksConnection";
};
export type WhatToSeeBlocksField_blocksConnection$key = {
  readonly " $data"?: WhatToSeeBlocksField_blocksConnection$data;
  readonly " $fragmentSpreads": FragmentRefs<"WhatToSeeBlocksField_blocksConnection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WhatToSeeBlocksField_blocksConnection",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WhatToSeeBlocksFieldSections_blocksConnection"
    }
  ],
  "type": "WhatToSeeBlockConnection",
  "abstractKey": null
};

(node as any).hash = "daefa6fdced723e709e3af9fd44527ae";

export default node;
